import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.institute.user.list');
import { OnInit, Input } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'wiz-portal-institute-user-list',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.institute.user.list/view.scss */
/* src/app/portal.institute.user.list/view.scss: no such file or directory */`],
})
export class PortalInstituteUserListComponent implements OnInit {
    constructor(@Inject( Service) public service: Service,@Inject( Title)  private title: Title) { }

    // public organizations = [
    //     { id: 'org-001', name: '한국과학기술정보연구원', logo: '', lastUpdated: '2025-09-20' },
    //     { id: 'org-002', name: '한국전자통신연구원', logo: '', lastUpdated: '2025-09-18' },
    //     { id: 'org-003', name: '한국원자력연구원', logo: '', lastUpdated: '2025-09-15' }
    // ];
    public organizations = [];

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow(true, "/authenticate");
        this.title.setTitle("기관 현황 - MY KREONET");
        await this.load();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code != 200) return await this.service.alert.error("Error!");
        this.organizations = data;
        await this.service.render();
    }

    public onSelect(org: any) {
        console.log('선택된 기관:', org);
    }
}

export default PortalInstituteUserListComponent;